import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import ContainedButton from "../../components/Buttons/ContainedButton";

const ReturnsSlice2 = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div className="col-3 row" style={{ maxWidth: 850 }}>
      <div
        style={{
          width: "100%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "2rem",
          marginTop: "5vh",
        }}
      >
        {t("What is our return policy?")}
      </div>
      <div
        style={{
          width: "70%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "0px",
          marginBottom: "0px",
        }}
      >
        {t(
          "For over 40 years our philosophy has been higher quality, longer lasting, and sustainable designs. Returning or exchanging an order is never fun but the modular construction of the evrbed allows us to work with you, unlike the big boxed brands. Our commitment to the environment extends into our policies. We do not believe in disposing of brand new mattresses and the low accountability service policies."
        )}
      </div>
      <div
        style={{
          width: "75%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "-40px",
          marginBottom: "0px",
          fontWeight: "bold",
        }}
      >
        {t(
          "evrbeds are made and designed individually for you and because of this we have less returns than industry average."
        )}
      </div>
      <div
        style={{
          width: "68%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "-40px",
          marginBottom: "0px",
        }}
      >
        {t(
          "Rather than returning you bed we invite you to see our evreasy exchange policy where we allow you to make a 1 time exchange for free."
        )}
      </div>
      <p
        style={{
          width: "74%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: "1.1rem",
          marginTop: "-40px",
          marginBottom: "0px",
        }}
      >
        Still not happy with your purchase? It happens. Let`s do the right
        thing, Please send in a request to{" "}
        {<span style={{ fontWeight: "bold" }}>returns@evrbed.com.</span>} A
        evrbed specialist will contact you to address any questions or concerns
        via phone or email. This covers picking up and recycling components.
      </p>
      <div
        style={{
          color: theme.COLORS.BLUE.lightBlue3,
          fontSize: 11,
          marginTop: "2vh",
        }}
      >
        {t("Please note we charge a 15% fee on returned mattresses.")}
      </div>
    </div>
  );
};

export default ReturnsSlice2;
